var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _path6, _linearGradient4, _ellipse, _linearGradient5, _ellipse2, _path7, _linearGradient6, _path8, _path9, _linearGradient7, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e",
    gradientUnits: "userSpaceOnUse",
    x1: -7642.318,
    y1: -1223.085,
    x2: -7641.318,
    y2: -1223.085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M34.958 20.329c-1.101-.933-8.776-.674-2.577 3.061M19.227 14.918s2.222.071 4.755-.818c2.533-.889 3.688-1.353 5.466-1.632s9.954.787 10.932 1.498"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M47.061 18.834s-1.289-.789-2.088.161c-.799.95.109 2.192.109 2.192l3.902-.858M47.006 22.681s1.289.789 2.088-.161c.799-.95-.109-2.192-.109-2.192M44.041 18.125l.956.841M49.071 22.549l.956.841"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M47.061 18.834s-1.289-.789-2.088.161c-.799.95.109 2.192.109 2.192l3.902-.858M47.006 22.681s1.289.789 2.088-.161c.799-.95-.109-2.192-.109-2.192M44.041 18.125l.956.841M49.071 22.549l.956.841"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e",
    gradientUnits: "userSpaceOnUse",
    x1: 33.763,
    y1: 20.784,
    x2: 64.288,
    y2: 20.784
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M34.388 29.991l7.155 6.127 1.536 1.35 1.062.934.773-.92 1.823-2.168 16.927-20.128-13.669-12.02"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e",
    gradientUnits: "userSpaceOnUse",
    x1: 32.509,
    y1: 13.192,
    x2: 50.62,
    y2: 13.192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M49.995 3.166L33.134 23.218"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M48.451 8.851L35.822 23.866M58.442 17.638L45.814 32.653M39.302 30.666l2.601 2.288M52.354 8.543l5.794 5.096M45.814 32.653a2.732 2.732 0 00-3.911.301M58.442 17.638a2.88 2.88 0 01-.294-3.999M36.752 25.608a2.85 2.85 0 00-.939-1.75"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e",
    gradientUnits: "userSpaceOnUse",
    x1: 39.389,
    y1: 27.841,
    x2: 43.035,
    y2: 27.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.212,
    cy: 27.841,
    rx: 1.198,
    ry: 1.225,
    fill: "none",
    stroke: "url(#SVGID_3_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e",
    gradientUnits: "userSpaceOnUse",
    x1: 51.288,
    y1: 13.693,
    x2: 54.934,
    y2: 13.693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.111,
    cy: 13.693,
    rx: 1.198,
    ry: 1.225,
    fill: "none",
    stroke: "url(#SVGID_4_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M52.366 8.528a2.732 2.732 0 01-3.911.301M56.653 56.553c-.448-.748-1.048-1.199-2.032-1.555-2.199-.798-11.178.206-14.59-.697-3.037-.803-9.882-7.763-9.882-7.763a2.398 2.398 0 01-.38-3.359 2.398 2.398 0 013.359-.38l6.355 4.709a3.285 3.285 0 001.955.645h9.675a.856.856 0 000-1.71h-5.357c-1.107 0-2.101-.499-2.004-2.004.025-1.039.879-1.565 1.973-1.582 3.571-.054 13.157.01 13.867.032 3.705.116 5.32 4.474 8.581 12.869"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e",
    gradientUnits: "userSpaceOnUse",
    x1: -8327.374,
    y1: -7394.973,
    x2: -8322.146,
    y2: -7394.973,
    gradientTransform: "scale(-1 1) rotate(-83.864 -45.078 -8266.748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1) rotate(83.864 65.025 -70.323)",
    fill: "none",
    stroke: "url(#SVGID_5_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M61.179 51.444h3.979v13.931h-3.979z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M18.761 26.364s3.955-1.422 6.043-.683c4.448 1.738 5.607 2.33 6.532 2.783.903.443 6.832 3.996 8.055 1.443 1.032-2.155-.899-3.015-1.367-3.291-2.039-1.201-5.644-3.226-5.644-3.226"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e",
    gradientUnits: "userSpaceOnUse",
    x1: 106.429,
    y1: 236.396,
    x2: 111.659,
    y2: 236.396,
    gradientTransform: "matrix(1 0 0 -1 -92.362 256.725)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_66ae67b1e08772ca2d7db789ca36b43a5428ecd7818fc804aa033bdd12b5dc8e)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M14.693 13.363h3.979v13.931h-3.979z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForPayment);
export default __webpack_public_path__ + "static/media/forPayment.359e4c73782e2bb6742eaf5b8fc9b191.svg";
export { ForwardRef as ReactComponent };